module.exports = __webpack_public_path__ + "img/52114123_L.5f2feca1.png";